<template>
    <header
        sstyle="z-index: 2400;"
        id="mainHeader"
        ref="headerNav"
        class="shadow-lg shadow-primary-600/30 dark:shadow-primary-900/40 w-full overflow-hidden z-40"
    >
        <div class="relative bg-primary-600/10 dark:bg-stone-900">
            <div class="w-full mx-auto max-w-screen-2xl px-8 3xl:px-0 h-auto md:h-32">
                <div
                    class="relative flex items-center justify-between py-6 justify-start space-x-10"
                    :class="!navigation ? 'animate-pulse' : ''"
                >
                    <div class="flex-none justify-start flex-shrink">
                        <span
                            class="w-autoh-20 -my-4 -mt-8 text-center hover:brightness-[0.9] dark:hover:brightness-[1.2] cursor-pointer"
                        >
                            <img
                                class="inline w-auto h-full"
                                src="~/assets/img/logo.svg"
                                alt=""
                            />
                        </span>
                    </div>

                    <nav
                        class="space-x-10 flex-1 flex flex-col md:flex-row justify-center items-center"
                    >
                        <UPopover mode="click" class="group">
                            <UButton
                                class="group-hover:text-white group-hover:bg-primary-600 dark:group-hover:bg-stone-800 h-16"
                                color="gray"
                                variant="ghost"
                                icon="i-mdi-chevron-down"
                            >
                                Apps
                            </UButton>

                            <template #panel="{ close }">
                                <div
                                    class="overflow-y-auto -m-4"
                                    style="max-height: calc(100vh - 150px)"
                                    @click="close"
                                >
                                    <div class="flex flex-col m-4">
                                        <template
                                            v-for="(app, index) in navigation"
                                        >
                                            <NuxtLink
                                                v-if="
                                                    checkPermission(
                                                        app.navigation
                                                            .credential,
                                                    ) && index !== 'navigation'
                                                "
                                                :to="app.url"
                                            >
                                                <UButton
                                                    color="gray"
                                                    variant="ghost"
                                                    class="hover:bg-stone-200/80 w-96 relative pl-16"
                                                >
                                                    <template #leading>
                                                        <Icon
                                                            class="absolute top-5 left-3 min-w-[48px] min-h-[48px] text-primary-500"
                                                            :icon="app.icon"
                                                        />
                                                    </template>
                                                    <div
                                                        class="text-left m-2 ml-4"
                                                    >
                                                        <h3
                                                            class="block font-bold tracking-widest"
                                                        >
                                                            {{ app.name }}
                                                        </h3>
                                                        <small
                                                            class="normal-case tracking-normal block text-stone-500"
                                                            >{{
                                                                app.title
                                                            }}</small
                                                        >
                                                        <p
                                                            class="normal-case font-normal tracking-normal block"
                                                        >
                                                            {{
                                                                app.description
                                                            }}
                                                        </p>
                                                    </div>
                                                </UButton>
                                            </NuxtLink>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </UPopover>

                        <UButton
                            class="hover:text-white hover:bg-primary-600 h-16"
                            color="gray"
                            variant="ghost"
                            @click="router.push('/home')"
                        >
                            Startseite
                        </UButton>

                        <!--<UButton 
                            class="hover:text-white hover:bg-primary-600 h-16"
                            color="gray" 
                            variant="ghost" 
                            @click="router.push('/support')"
                        >
                            Support
                        </UButton>-->
                        <UPopover mode="click" class="group">
                            <UButton
                                class="group-hover:text-white group-hover:bg-primary-600 dark:group-hover:bg-stone-800 h-16"
                                color="gray"
                                variant="ghost"
                                trailing-icon="i-mdi-chevron-down"
                            >
                                Funktionen
                            </UButton>

                            <template #panel="{ close }">
                                <div
                                    class="overflow-y-auto -m-4"
                                    style="max-height: calc(100vh - 150px)"
                                    @click="close"
                                >
                                    <div class="flex flex-col m-4">
                                        <template
                                            v-for="(nav, index) in navigation?.[
                                                `${router.currentRoute.value.fullPath.split('/')[1]}`
                                            ]?.navigation ||
                                            navigation.eijns.navigation"
                                        >
                                            <UButton
                                                v-if="
                                                    checkPermission(
                                                        nav.credential,
                                                    )
                                                "
                                                :to="`/${index}`"
                                                color="gray"
                                                variant="ghost"
                                                class="hover:bg-stone-200/80 w-96 relative pl-10"
                                            >
                                                <template #leading>
                                                    <Icon
                                                        class="absolute top-3 left-3 min-w-[32px] min-h-[32px] text-primary-500"
                                                        :icon="nav.icon"
                                                    />
                                                </template>
                                                <div class="text-left m-0 ml-4">
                                                    <h3
                                                        class="block font-bold tracking-widest"
                                                    >
                                                        {{ nav.name }}
                                                    </h3>
                                                    <small
                                                        class="normal-case tracking-normal block text-stone-500"
                                                        >{{ nav.title }}</small
                                                    >
                                                </div>
                                            </UButton>
                                        </template>
                                        <!-- <div v-if="0" class="p-4 opacity-50 max-w-72">Hier gibt es scheinbar nix für dich zu sehen, es kann aber auch sein, dass dir noch keine Funktion in diesem Modul freigegeben wurde.</div> -->
                                    </div>
                                    <div
                                        class="flex flex-row bg-black/20 mt-4 p-4 pl-8 text-sm leading-6"
                                        v-if="health"
                                    >
                                        <div class="grow">Systemstatus</div>
                                        <UBadge
                                            color="green"
                                            v-if="health.message == 'OK'"
                                            >OK</UBadge
                                        >
                                        <UBadge
                                            color="yellow"
                                            v-if="health.message == 'BUSY'"
                                            >BUSY</UBadge
                                        >
                                        <UBadge
                                            color="red"
                                            v-if="health.message == 'SLOW'"
                                            >SLOW</UBadge
                                        >
                                    </div>
                                </div>
                            </template>
                        </UPopover>
                    </nav>

                    <!-- Profile dropdown -->
                    <div class="relative justify-end flex flex-none">
                        <UPopover
                            mode="click"
                            class="group"
                            :popper="{ placement: 'bottom-end' }"
                            :uci="{
                                base: 'overflow-hidden focus:outline-none p-4 relative -translate-x-1/2 left-8',
                            }"
                        >
                            <div class="border-b-8 border-transparent -mb-2">
                                <!--<UTooltip :text="messagesCount > 0 ? `Du hast ${messagesCount} ungelese Nachricht${messagesCount > 1 ? 'en' : ''} oder Aufgabe${messagesCount > 1 ? 'n' : ''}...` : 'Du hast keine ungelesenen Nachrichten oder Aufgaben'">
                                </UTooltip>-->
                                <UAvatar
                                    @click="!auth ? router.go('/logout') : null"
                                    :src="me.avatar"
                                    :alt="
                                        [
                                            me.personal?.firstname,
                                            me.personal?.lastname,
                                        ]
                                            .filter((e) => e)
                                            .join(' ')
                                    "
                                    size="3xl"
                                    :chip-color="
                                        me.messagesCount > 0 ? 'red' : null
                                    "
                                    chip-position="bottom-right"
                                    :chip-text="me.messagesCount"
                                    :ui="{
                                        wrapper: 'ring ring-primary-600',
                                        rrounded: 'rounded-lg',
                                        chip: {
                                            size: { '3xl': 'p-3 px-2' },
                                            position: {
                                                'bottom-right':
                                                    '-bottom-2 -right-2',
                                            },
                                        },
                                    }"
                                />
                            </div>

                            <template #panel="{ close }">
                                <div
                                    class="w-96 overflow-y-auto -m-4"
                                    style="max-height: calc(100vh - 150px)"
                                >
                                    <a
                                        class="cursor-default flex flex-row px-8 py-6 border-b border-stone-500 bg-primary-800 text-white"
                                    >
                                        <div class="grow">
                                            <p
                                                class="text-lg uppercase font-bold tracking-widest"
                                            >
                                                <a href="/home?refresh=session"
                                                    >{{
                                                        me.personal?.firstname
                                                    }}
                                                    {{
                                                        me.personal?.lastname
                                                    }}</a
                                                >
                                            </p>
                                            <p class="text-sm opacity-60">
                                                {{ me.username }}
                                            </p>
                                        </div>
                                        <UTooltip
                                            :openDelay="1000"
                                            :popper="{ placement: 'left' }"
                                            :text="
                                                colorMode.value === 'dark'
                                                    ? 'Helles Erscheinungsbild nutzen'
                                                    : 'Zur dunklen Seite wechseln'
                                            "
                                        >
                                            <UIcon
                                                @click="
                                                    isDark = true;
                                                    delay(close);
                                                "
                                                name="i-mdi-theme-light-dark"
                                                class="w-8 h-8 cursor-pointer duration-500 -mr-4 transition-all ease-[cubic-bezier(.75,-0.5,0,1.75)]"
                                                :class="`${isDark ? 'rotate-180' : ''}`"
                                            />
                                        </UTooltip>
                                    </a>
                                    <div
                                        class="block aspect-square h-72 w-full bg-cover bg-center"
                                        :style="{
                                            backgroundImage: `url(${me.avatar})`,
                                        }"
                                        v-if="me.avatar"
                                    ></div>
                                    <div
                                        class="bg-stone-100 text-black dark:bg-stone-900 dark:text-white px-8 pt-6 pb-4 sm:px-8 sm:pt-8 pr-4"
                                    >
                                        <div>
                                            <h3
                                                class="text-base font-medium dark:text-stone-200 uppercase tracking-widest"
                                            >
                                                Dein Benutzerkonto
                                            </h3>
                                            <ul
                                                role="list"
                                                class="mt-4 space-y-2"
                                            >
                                                <li
                                                    @click="close"
                                                    class="truncate text-base"
                                                >
                                                    <NuxtLink
                                                        to="/messages"
                                                        class="block font-medium opacity-50 hover:opacity-100"
                                                    >
                                                        Benachrichtigungen
                                                        <UBadge
                                                            v-if="
                                                                me.messagesCount >
                                                                0
                                                            "
                                                            color="indigo"
                                                            class="float-right"
                                                            >{{
                                                                me.messagesCount
                                                            }}</UBadge
                                                        >
                                                    </NuxtLink>
                                                </li>
                                                <li class="truncate text-base">
                                                    <NuxtLink
                                                        to="/account"
                                                        class="block font-medium opacity-50 hover:opacity-100"
                                                    >
                                                        Persönliche Daten
                                                    </NuxtLink>
                                                </li>
                                                <li class="truncate text-base">
                                                    <NuxtLink
                                                        tto="/mydashboard"
                                                        class="block font-medium opacity-20 cursor-not-allowed hhover:opacity-100"
                                                    >
                                                        Individuelles Dashboard
                                                    </NuxtLink>
                                                </li>
                                                <!--<li class="truncate text-base">
                                                    <NuxtLink @click.prevent.stop="isDark = true" class="block font-medium opacity-50 hover:opacity-100 cursor-pointer">
                                                        <template v-if="colorMode.value === 'dark'">
                                                            Zum hellen Erscheinungsbild wechseln
                                                        </template>
                                                        <template v-else>
                                                            Zur dunklen Seite wechseln
                                                        </template>
                                                    </NuxtLink>
                                                </li>-->
                                                <li>
                                                    <hr
                                                        class="opacity-20 my-4 -mx-8"
                                                    />
                                                </li>
                                                <li
                                                    @click="close"
                                                    class="truncate text-base"
                                                >
                                                    <NuxtLink
                                                        to="/logout"
                                                        class="block font-medium opacity-50 hover:opacity-100 cursor-pointer"
                                                    >
                                                        Abmelden
                                                    </NuxtLink>
                                                </li>
                                            </ul>
                                        </div>
                                        <!--<div class="mt-5 text-sm">
                                            <a href="#" class="font-medium text-primary-400 hover:text-primary-100">
                                                Log-Daten anzeigen
                                                <span aria-hidden="true"> &rarr;</span>
                                            </a>
                                        </div>-->
                                    </div>
                                </div>
                            </template>
                        </UPopover>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <header class="ssticky top-0 z-20">
        <!-- PROGRESSBAR -->
        <div
            class="relative w-full bg-stone-400 h-1 pprogress-indeterminate overflow-x-hidden"
        >
            <NuxtLoadingIndicator
                :height="4"
                :color="colorMode.value === 'dark' ? '#aad400' : 'pink'"
                :duration="12345"
                :throttle="666"
                class="!relative"
            />
            <!--<div class="absolute top-0 left-0 w-full h-1 transition-all duration-500" :class="(loading) ? 'opacity-100' : 'opacity-0'">
                <div class="bg-stone-600 opacity-150 progress-bar-shadow" style="width: 100%"></div>
                <div class="bg-primary-600 progress-bar" style="width: 100%"></div>
            </div>-->
            <div
                class="absolute top-0 left-0 w-full h-1 bg-[#aad400] dark:bg-primary-600 transition-all duration-0 1000 ease-in-out opacity-100 w-screen"
                cclass="(!loading) ? 'opacity-100 w-screen' : 'opacity-0 w-0'"
            ></div>
        </div>

        <!-- SECONDARY NAV -->
        <div
            dblclick.stop.prevent="toggleHeader"
            ttitle="Doppelklick um Header auszublenden"
            class="relative bg-primary-600 hover:bg-primary-600 dark:bg-stone-800 dark:hover:bg-stone-700/50 h-fit overflow-hidden select-none max-h-32 border-b-2 border-primary-700 dark:border-stone-600 text-white"
        >
            <div class="w-full h-[56px] mx-auto max-w-screen-2xl px-8 3xl:px-0">
                <div
                    class="flex flex-row items-center justify-between md:justify-start md:space-x-2 h-[56px]"
                >
                    <div class="shrink whitespace-nowrap group">
                        <h2
                            class="font-semibold block cursor-default flex flex-row space-x-2 items-center"
                        >
                            <template
                                v-if="$route.meta?.favourable && favourites"
                            >
                                <UTooltip
                                    text="Als Favorit markieren"
                                    v-if="
                                        Object.values(favourites).find(
                                            (e) => e === $route.fullPath,
                                        ) === null
                                    "
                                >
                                    <Icon
                                        class="w-8 h-8 cursor-pointer opacity-20 hover:opacity-60"
                                        icon="mdi:bookmark-outline"
                                        @click="favourites.push(route.fullPath)"
                                    />
                                </UTooltip>
                                <UTooltip
                                    text="Du hast diese Seite Favorisiert"
                                    v-else
                                >
                                    <Icon
                                        class="w-8 h-8 cursor-pointer opacity-80 hover:opacity-100 text-primary-500"
                                        icon="mdi:bookmark-check"
                                        @click="
                                            favourites.filter(
                                                (e) => e !== route.fullPath,
                                            )
                                        "
                                    />
                                </UTooltip>
                            </template>
                            <template v-if="appStore">
                                <span class="uppercase">{{
                                    navigation?.[
                                        `${router.currentRoute.value.fullPath.split('/')[1]}`
                                    ]?.name ||
                                    appStore.title ||
                                    'EIJNS'
                                }}</span>
                                <sup
                                    v-if="
                                        appStore.runtimeConfig?.package?.version
                                    "
                                    class="font-light text-xs lowercase"
                                    >{{
                                        navigation?.[
                                            `${router.currentRoute.value.fullPath.split('/')[1]}`
                                        ]?.version ||
                                        appStore.runtimeConfig?.package?.version
                                    }}</sup
                                >
                            </template>
                        </h2>
                    </div>
                    <div class="grow"></div>
                    <div class="flex flex-row gap-2 items-center">
                        <UBadge
                            v-if="
                                appStore.badge && !Array.isArray(appStore.badge)
                            "
                            :variant="appStore.badge?.variant || 'solid'"
                            :color="appStore.badge?.color || 'primary'"
                            :label="appStore.badge?.label || '<NO_LABEL>'"
                            class="text-black font-bold uppercase"
                        />
                        <template v-else>
                            <div v-for="badge of appStore.badge">
                                <UTooltip
                                    :text="badge.tooltip"
                                    :prevent="badge.tooltip ? false : true"
                                    class="flex flex-row items-center"
                                >
                                    <UBadge
                                        :variant="badge.variant || 'solid'"
                                        :color="badge.color || 'primary'"
                                        :label="badge.label || '<NO_LABEL>'"
                                        class="uppercase text-black font-bold"
                                    />
                                </UTooltip>
                            </div>
                        </template>
                        <span
                            class="uppercase tracking-widest font-bold"
                            v-html="appStore.name || ''"
                        ></span>
                    </div>

                    <nav class="space-x-2 shrink normal-case flex header-menu">
                        <slot></slot>
                        <template v-if="contextMenu && contextMenu[0]">
                            <UDropdown
                                :items="contextMenu"
                                :ui="{
                                    item: {
                                        disabled: 'cursor-text select-text',
                                    },
                                    width: 'w-fit !-mt-1',
                                }"
                                :popper="{ placement: 'bottom-end' }"
                            >
                                <UButton
                                    variant="ghost"
                                    color="gray"
                                    icon="i-mdi-menu"
                                />
                                <template #header="{ item }">
                                    <div class="relative w-full h-4">
                                        <div
                                            class="text-left bg-stone-800/50 absolute -left-4 -right-4 -top-2.5 px-4 py-2.5"
                                        >
                                            <p
                                                class="truncate uppercase text-xs font-medium text-stone-500"
                                            >
                                                {{ item.label }}
                                            </p>
                                        </div>
                                    </div>
                                </template>
                                <template #trailing="{ item }">
                                    <div
                                        class="w-full flex flex-row gap-2 items-center"
                                    >
                                        <UIcon
                                            :name="item.icon"
                                            class="w-6 h-6 text-stone-400"
                                        />
                                        <div class="grow text-left">
                                            {{ item.label }}
                                        </div>
                                        <UIcon
                                            :name="item.trailing"
                                            class="w-6 h-6 text-stone-400"
                                        />
                                    </div>
                                </template>
                            </UDropdown>
                        </template>
                    </nav>
                </div>
            </div>
        </div>
    </header>
</template>
<script setup>
//import { useAppStore } from '~/stores/app.js'
//import { useUserStore } from '~/stores/user.js'
//import { storeToRefs } from 'pinia'
const newMessagesSoundBase64 =
    'data:audio/mpeg;base64,SUQzBAAAAAAAIlRTU0UAAAAOAAADTGF2ZjYwLjMuMTAwAAAAAAAAAAAAAAD/+1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABJbmZvAAAADwAAACMAABKrABISGRkZICAgJycnLi4uNTU1PDxDQ0NKSkpRUVFYWFhfX19mZmZtbXR0dHt7e4KCgomJiZCQkJeXl56epaWlrKyss7Ozurq6wcHByMjIz8/W1tbd3d3k5OTr6+vy8vL5+fn//wAAAABMYXZjNjAuMy4AAAAAAAAAAAAAAAAkBIQAAAAAAAASq/YrjTMAAAAAAAAAAAAAAAAAAAAA//sgZAAAANEAXcUEYAAPQAfAoAgAA+BlfhjSgAA1gGIDACAA9AMBgC4fUCAJg+fSUWD4Pg+DgIAhlPy4fdX///xAZ/08TggGKgTB8H3nR7FYUhgEKtJrUjLxEC+DCQAugt2//ESCI74VBX+1n6fuudYZ+j7xt+65X60AJSj14AAFaP/7ImQEAfDaBdlnZEAMDoBosOUAAAR4GTNM+0AgPIGjABAIAAgqAa9Kmr83q1NjOiLljwifEoa4MCP6mf+wYtHf/mWsfFwAwAAkCHEU2MDkR0xT2Fjm0TCEC66mDO3/ZJA7v//2LqDhWZDHiJQ38x/9GnvVnCbMd0oAIACwAA6AAOYZ//siZAUH8RAGTcn90AwNoEjABGAAA+QZIg17gAAwAaKAA4gADIepcmeQsDialjX3cjDX5Z//0oNKB8ROO4cFAZeob/b//ejq11mdBCZ0w/wIj6rfEPkhsHNwOK4YHC7ambgStj9P//+qDQY+KEPoVs//39emCAADUTPGwwpBKzuMEBP/+yBkBw3xFgbJEz7gCA1gCKAAAAADUBkmDPtgMDSAIwARDACfDMyKBAwSolMkgCO02P//vCawkJfZqj3WbKv/3vnlEP00GScaGpgjiiG6ecSdSlGMB5bZdtNZl1k9//9IJAIHDuT6mf//b79/phgAACGhXYKCrmhsrwbCyFyiHrGH//siZAoN8QgGyRM+0AAAAAjQBAABBAQbHg17QAA2gCKAAAAA3i8mv8//z8e8aNf/6hGKAsEwRBejF0fTPJwMafBARBOqRrkDznR33/v/R//1qegBuozNUU//768f/F5TM3cMF0Lk1fWCDxUUyQMAwOigu924xbc7E/9Ho2uXXnlJts//+yJkEg3w/QZHgx7YAAxgCMAAAAAD+BceLHtgACIAIwAQAABXf//7Uu796CJmi5zBeBENuQ407oMCEcWBFY2WP5Kzna6n07ZZjHhx7zbvs3N/7GrqLjHAJgrgxG2aCYdaACRqiUp5+5XcBYuQZ7//11of9u9hb///Vr3rLKmehgbBdv/7IGQXD/DlBceDHtgACmAIwAAAAAPMGR4Me0AAIoBjAAAAAGrQVQfpKBjSYL9TuqXLpUF10/Z//2exNnx2iln////pLdBTZgOah4n5p33BQFaTwzFi0Z0M/6fUcYsUXeu7XdX60Xmf6N/aleJIwAlCYo7YZMKIDM30jdPYNXTbf///+yJkHw/wvwXHgx3IAA+gGKAEAAADfBcgDHcgIDCAIsAAAADFS5oYPUw2OYhvV2s///6uiWoIAAiCE8wSFY4mnc8Ckf2uP+ACFu//8+TCAlDFoUa7Rvr7f5z/f/NwpGgwpBs/JfoFtxoYv9+AGTMvtF/+prPd//c0QJwN/X2N/+SbHP/7IGQmjfDdBciTuTCYC8AYsAAAAAOkGR4O6MJANABigAAAAMf71di6WKXyMJAnPxA1D1JEGK1NskAW+393///aGjlJymAxof/dIL0wUTMjzSl/+3ocJwTGs3fqdTq5a3etv//rc61+uqpTERkAg+m/EuHSacz6zVe+Z+j1dTWC1p7/+yJkLI3wvwVHg7p4gAAACNAAAAEDZBEkTmEiADUAIsAAAABdyupzOSZvWvv7G99QUMRZjAqAE7SMgMQeGP//yg8OuA5o6ogYv6KFfSuj///9VSAm1oGARadNxQHOxANihGDn//wgmOJMrBi9F0AByxMj1HnGJwc///uF51oViobNSP/7ImQ7jfChBUcDHcAAEIAYoAAAAAMMESZH8MBgJYAjAAAAAHoCqqBdXv//7XIv9CqHmWmA4DHB4OD4zFQ6efbP9/0Xdy+QtqXSlU8fMYlRZ/xZOP63IxwwP6yoEB07cmgzLjBNf/9gohAlAgGF7+tLZct1JeLeKzv6EJ//oRUlAqKk//sgZEeN8LgEyAuYSIQAwAjAAAABAtATJk5gwiA3gCLAAAAAh5/mg8+oa//////64DYfRQhS2///v/3L10oijYzDTEwfAMGBggEorsvD//9C2lP/Gkrnm7F5X/+z+lUCAAAAAw0LD1gNETmNzE0we8jWJJDgxouR6g3/zH+ff5qE9f/7ImRYDfCwBUeDuUiAEOAIoAAAAAMEESBOYMIAOYBiwBAAAHR7e+qLp+jFa1V3zGve9/DIlA0CAAhIAAABSpY970spjG9r0pdI1r2t5s7U2hxiAKlRsHa+DztH/r3+zq50mjobJkQFkAEyJRzyY5pU/ZKsKt/93lYjCrf/9smY8RhQ//sgZGCN8IIESAGbGBANYAiwAAAAAugTJDWwACAlgGMCggAA15//3THPSUP1MT5N3//9nfv/H2I5K+fK8/nqwtIIXvX///7//vv/+frV8gUwAAEgAACnKjCwSHCyislNf/////UahCRNNN+abOJjU4KoWUNqu/TinRNlFO1P0O6AqP/7ImRwAAGxK8cucEAAKSIIlsGIAEeomWoZJ4AAOxQjQwDQAPdAADghdQwZNigHnAbmZhYtueWD9ZS8zjf/4CuHe72jrFJFyJ8U8h09KpEEb+AIVQABanZemBRuajUUoZvE2wTT00F2gu4c7//byL/+oPhzt15eirs//dqEWqQiKcAC//siZEmB8RogYm8g4A4NoAmA4QgAA+h/geYAsPA1AmJAABwQFimlMSVRrPCKyjwqg0OtKqQLa5LrPft4v//YC8colcwcckwe3//iy2EM2GT1VTBEaYABWwAANV6jzTDMxwcDgEEgCZiLH+Lahef///9vEP/6hC4oIw5gkY/8u3qFnfL/+yBkSgHxNx9ZawBsLglgCNAAQgIEWH9lrIFO+DqCY0AQCAAmFlAMJzQAZMY32gFmYQrUEIk769H0euq2KhuXbm8+d/7eI//6Bg52HwyKNIv/d//zj/WqkQpvAAOABjWqsmqt2HIKiRRf6U7gazlZy5lf/4bLUOf8m/aPot+hzW0L//siZEgB8S8f2/sMObwNYIiwBAIQBLR/WeyBUKAxACNAEQwIXts6SQQIUoAAYofqbZZNswAtwMEOXG38pp/n2M+fbxO3/4QtaBDYmaK/2f0L/XpFdrdFvor/AA0gAAFtHEEnS4rFUWgXZfz0hJGTOM/7eCrf/QCDsgABBvsR62uKJo7/+yJkRIHw9x/ZYwA7zg5gGMAAQAAEBH1V7QDu4D0AIwAhCTDc+vpSRdQhuAAWZYypwKzdR2KcLLpTKtOraxy5+J2//DRZSElDjr37ej+hj1MfmlrV1uo8L6INmOe5lISux/Gdxmx38Qt/+FedvL2hCtZqxeJw6NDSCUHaTc3+IW//CP/7IGRFgdEJH9rp4Du8D6AY0gBAAAO0f1+MAO8wN4BiwAAAAB+tK/WPT/7t9dW1oDW30McqsCRFMowzANZAIdrLRobXPwtv/xZmIaEHNd/gZg5D2tYp97F1b1nIoDRkMX3DHgRnb/tcjVvn4W3/4RTZc07suV//9rOgfmkrTe8ttcj/+yJkRg/wth9Qg2A7UAAACOAAAAEDAH88DYDtQDiAYwAAAABa3DSy4XWEu3DIAJ0ruvwtv/wEdL1LkpxKfVer/54O2/ryxrNhgJBkxXjNuBXeqqrUFnv4W3/4syE72ey37k00J6qf0aLgwtb+Hn0RnMW4zHwdnD+NfjNjv4W3/4Rbdv/7IGRXD/C0H9ADYCtQD6AIoAAAAALMfT4NgK1AOIAigAAAAKf7aWJ/pQgx/quYjnZbXhCrzTDkTY0uHAIQN0bm9YW3/4COt7EwFT0arvpyv7j9nysQMcsa0RUOMKqgNTQ7WZDQ2ufg2//AmQ1QFQt9CucfeZ9f+m/xZW9V5iA0GDH/+yJkYI/wvB/OA2ArUA3ACMAAAAAC3H84DYCtQDoAYoAAAAB+oxwGZ2/7XI1b5+Nb/8La7EPenkef/5S6un2+3kHvLc5A6zDT0IPaEu3DIAR0rut4W3/4cfLHKrEkZTE8s2YBfqqqtQWe/hY7/8PbT/T9n////1LW6k3ACDZi3mY2Ev/7ImRqj/CyH04DYCtQDUAYwAAAAALsfzINgK1AOAAigAAAAM4fxr8Zsd/Gt/+FpendTs6v9sbVehOr46FTf3nbEjM40jzgSkbHM6/8LHf/hx/tX///8+rj7WTFChAxyqzURRmMWzDawB1ayqtDa5+Db/8CyKGndli9q/9P/2bd6d6r//sgZHWN8LYfzYtgE1APYAigAAAAAsR9Mg2ArUA6AGLAEAAAzDpjACMOyAxADl3v+xCNT/Pwbf/g2iqE3o2+P///sX5yLQjYAAiAAA83HYGKgrA98ZcfBkv2AHnsDc9lLksFSPS56Ov5Uwvud6/fQSpOEvsKAJj/icIDutMpbSQS/f/7ImR/D/C6H8sDYCtQAAAI0AQAAQLEfS4NgK1gIQAjQACIAD9v///Bja/8N+hLrqf2Cz//9T7hfvrVpNQbbgKgkxNWTE4XVI7i64dBHbr//77foo0v234X9LXrtba/6//7v1L1M1c+xPwIn2aswhMGiIygdB243P9f0wbf/jL/1auo//sgZJON8LEfSwNgK1AOYAiwAAAAAoh/NCyArXAtAGMAAAAA/p3u//7WHbUf2uUqQCwKBRFLYxS0AWUhMIT1rjfwx6s1JfnrP9Psvrd7P//kj3v0I5qvMOmMAQw7NDDQQXe766I1P8/f/WhmT1b238H//RYpO3V98r/zSWsUy+hEX//7ImSgjfC4H0oLYBNQDQAYwAAiAAL4fyQOAE1AMIBjAAAAAF3cafbQ1LQXqE3T4nCKb//c+PGvYzR7Lrci1vV/fb/9ehcxBlS8TC4cHSKqlHc1RdtY6ABDXx5Gut2t4jVBH66U7P7xf1NcRQtWd3XlG9X6VewPACZZhWaYOBuRFHfp//siZKwB8NIZT1IgS1wPYBigACIAA6B9ICNsQsAugGKAAAAAU/Z+vziCXvkr66me0X6NQLzNJxs26koZ/KWf/UdmP/6nsp4zITX5+W///iu5SuKlbkYLEGaj3BTC/T+63t395H/9ux1V///99C/jvrckP4IQ++RND9zpvZkRBFANYXb/+yBksg/w+R/HATwosAyACLAAAAADZH0aDYBNADGAYwAAAAC0YxjO/V+6jetyOv2WN30X/VGVc0iAU6QVAjeJcnQk0iRIyChQUFBQSCgorvLP9v+Ij1Xtw63Oozv6lUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV//siZLcN8M8Gx4h7eJAK4AigAAAAA9R/GA4ATIA9AGKAAAAAVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVX/+yBkvQ/wqQZHAFp4kAvACLAAAAAD6B0cAO3iQDyAYYABCABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV//siZMQP8NwGxgB7CLAAAAjQAAABAqAZGgAzQEArgGKAAAAAVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVX/+yJk1Y3wowZGgDpgkAogGKAAAAAC4GcwaABpYDeAYYABCABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7IGTjD/DJCEiAzzCiDiAIEAAAAAAAAaQAAAAgAAA0gAAABFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVU=';

///const { storeMe } = await useMe()
//const { me.username, me.personal, favourites, me.avatar, messagesCount } = storeToRefs(storeMe)

//const { eijnsJWT } = await useGlobals()
const auth = useAuth();
const appStore = useAppStore();
const { contextMenu, globals, me, badge } = storeToRefs(appStore);
// console.log('me', me.value)

const navigation = ref();
import baseNavigation from '~/navigation.json';

const nuxtApp = useNuxtApp();
const loading = ref(false);

nuxtApp.hook('page:start', () => {
    // console.log('loading.value = true')
    loading.value = true;
});

nuxtApp.hook('page:finish', () => {
    // console.log('loading.value = false')
    loading.value = false;
});

// const preferences = me.value.preferences // await usePreferences()
const colorMode = useColorMode();
//colorMode.preference = 'dark'
const isDark = computed({
    get() {
        return (
            me.value?.preferences?.colorMode === 'dark' ||
            colorMode.value === 'dark'
        );
    },
    async set() {
        colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark';
        me.value.preferences.colorMode = await usePreferences(
            'colorMode',
            colorMode.preference,
        );
    },
});

if (me.value?.preferences?.colorMode) {
    colorMode.preference =
        me.value?.preferences?.colorMode === 'dark' ? 'dark' : 'light';
}

const props = defineProps({
    appTitle: {
        type: String,
    },
    appVersion: {
        type: String,
    },
    appSubTitle: {
        type: String,
    },
    appTabs: {
        type: Object,
    },
    store: {
        type: Object,
    },
});

/*const appStore = useAppStore()
    const appStoreState = storeToRefs(appStore)
    const { favourites, contextMenu, globals } = storeToRefs(appStore)

    const userStore = useUserStore()
    const userStoreState = storeToRefs(userStore)
    const { avatar } = storeToRefs(userStore)*/

/* ICONS LADEN */
import { Icon } from '@iconify/vue';

/* ROUTE LADEN */
const route = useRoute();
const router = useRouter();

const delay = (func) => {
    setTimeout(() => {
        func();
    }, 789);
};

const toggleHeader = (ev) => {
    mainScrollTop.value = 'toggle';
};

/*const fetchNavigation = await useFetch(
        '/api/navigation',
        { 
            method: 'GET',
            headers: {
                ...headers,
            },
            server: false,
            immediate: true,
            onResponse({ request, response, options }) {
                console.log('response._data', response._data)

                if (!response.ok) {
                    return { error: response._data }
                }

                navigation.value = response._data
            },
            onResponseError({ request, response, options }) {
                return { error: response._data }
            },
        }
    )

    if (fetchNavigation.error.value) {
        appStore.error(null, {
            ...fetchNavigation.error.value,
            description: 'Die Navigation konnte nicht geladen werden',
            solution: 'Gib jemandem Bescheid, der sich damit auskennt',
        })
    }*/

/*const fetchMessagesCount = useFetch(
        '/api/user/messages/count',
        { 
            method: 'GET',
            headers: {
                ...headers,
            },
            onRequest({ request, options }) {
            },
            onRequestError({ request, options, error }) {
            },
            onResponse({ request, response, options }) {
                console.log(response._data)
            },
            onmessage({ request, response, options }) {
                console.log(response)
                const data = JSON.parse(response._data.data);
                storeMe.set('messagesCount', response._data.count)
            },
            onResponseError({ request, response, options }) {
            },
        }
    )*/

const sso = {
    domain: 'IWB-GOTHA',
    initials: 'TF',
    username: 'feher',
    displayName: 'Tamás Fehér',
    groups: [
        'IWB-GOTHA\APplusAdministratoren',
        'IWB-GOTHA\APplusBenutzer',
        'IWB-GOTHA\DVG-SRV-IWB-02',
        'IWB-GOTHA\Dom�nen-Benutzer',
        'IWB-GOTHA\Freigabe FERTIGUNG',
        'IWB-GOTHA\G-MailStoreUser',
        'IWB-GOTHA\G-SSL-User-Vollzugriff',
        'IWB-GOTHA\K',
        'IWB-GOTHA\L-MARKETIING-Laufwerk R mount',
        'IWB-GOTHA\MG',
        'IWB-GOTHA\Mailing',
        'IWB-GOTHA\O-BookStack_admin',
        'IWB-GOTHA\O-BookStack_dev',
        'IWB-GOTHA\O-BookStack_editor',
        'IWB-GOTHA\O-MARKETING-RW',
        'IWB-GOTHA\O-PROJEKTIERUNG-B�nder-RW',
        'IWB-GOTHA\O-PROJEKTIERUNG-E-Prog-RW',
        'IWB-GOTHA\O-PROJEKTIERUNG-RW',
        'IWB-GOTHA\O-PROJEKTIERUNG-Serienprojekte-RW',
        'IWB-GOTHA\O-PROJEKTIERUNG-_Laufende Projekte-RW',
        'IWB-GOTHA\O-PROJEKTIERUNG-interne Projekt-RW',
        'IWB-GOTHA\O-PZEIT-RW',
        'IWB-GOTHA\proFILE.Konstruktion',
        'IWB-GOTHA\prt_Verwaltung',
        'IWB-GOTHA\wikiadmins',
        'IWB-GOTHA\wikibenutzer',
        'NT AUTHORITY\LogonSessionId_0_108879884',
        'NT-AUTORIT�T\Authentifizierte Benutzer',
        'NT-AUTORIT�T\Diese Organisation',
        'NT-AUTORIT�T\INTERAKTIV',
        'NT-AUTORIT�T\INTERAKTIVE REMOTEANMELDUNG',
        'SRV-IWB-CAD\docker-users',
        'VORDEFINIERT\Administratoren',
        'VORDEFINIERT\Benutzer',
        'VORDEFINIERT\Leistungsprotokollbenutzer',
        'VORDEFINIERT\Remotedesktopbenutzer',
        'Verbindliche Beschriftung\Mittlere Verbindlichkeitsstufe',
        '\Jeder',
        '\LOKAL',
        '\Von der Authentifizierungsstelle best�tigte ID',
    ],
};

const health = ref(null);
/*const health = ref(useFetch(
        '/api/public/health', 
        { 
            method: 'GET',
            onRequest({ request, options }) {
            },
            onRequestError({ request, options, error }) {
            },
            async onResponse({ request, response, options }) {
                return response._data
            },
            onResponseError({ request, response, options }) {
                console.error('/api/public/health', response)

                /*addNotification(response._data.statusMessage, {
                    title: 'Fehler beim lesen der App-Erreichbarkeit',
                    code: response._data.statusCode,
                    type: 'error',
                    error: {...response._data},
                })* /
            },
        }
    ));*/

//const health = ref(null)
// const credentials = useFetch(
//     '/api/me/credentials',
//     {
//         method: 'GET',
//         server: false,
//         immediate: true,
//         async onResponse({ request, response, options }) {
//             return response._data
//         },
//         // onResponseError({ request, response, options }) {
//         //     console.error('/api/public/health', response)
//         // },
//     }
// )

const playNewMessageSound = () => {
    const sound = new Audio(newMessagesSoundBase64);
    sound.play();
};

const newMessages = ref();
watch(
    () => me.messagesCount,
    (newVal, oldval) => {
        if (
            !parseInt(oldval) &&
            parseInt(localStorage.getItem('eijns-message-count'))
        ) {
            oldval = parseInt(localStorage.getItem('eijns-message-count'));
        }

        console.log(
            'messagesCount',
            newVal,
            oldval,
            parseInt(oldval),
            newVal > oldval,
        );

        if (parseInt(oldval) > -1 && newVal > oldval) {
            console.log('messagesCount ... play');
            playNewMessageSound();
        }

        localStorage.setItem('eijns-message-count', newVal);
    },
);

const checkPermission = (cred) => {
    return Object.keys(me.value.credentials).find(
        (e) => e.startsWith(`${cred}`) && me.value.credentials[e] === true,
    );
};

onServerPrefetch(async () => {});

onBeforeMount(() => {});

let eventMessagesCount = null;

onMounted(async () => {
    const config = useRuntimeConfig();
    /*eventMessagesCount = new EventSource(`${config.app.baseURL}api/user/messages/count`)
        eventMessagesCount.onmessage = (event) => {
            const data = JSON.parse(event.data)
            appStore.set('me.messagesCount', data.count)
            //messages.value.push(data);
        };

        eventMessagesCount.onerror = (event) => {
            console.error(event)
        };*/

    const nuxtApp = useNuxtApp();
    const eijnsApp = (await nuxtApp.$eijnsApp) || { navigation: {} };

    navigation.value = {
        [`${baseNavigation.meta.name.toLowerCase()}`]: {
            ...baseNavigation.meta,
            url: `/home`,
            navigation: baseNavigation.navigation,
        },
    };

    // console.log('eijnsApp', eijnsApp)

    Object.keys(eijnsApp.navigation).forEach((e) => {
        const order =
            eijnsApp.navigation[e].meta?.order !== undefined
                ? eijnsApp.navigation[e].meta?.order
                : '99999';
        const name = eijnsApp.navigation[e].meta.name.toLowerCase();

        navigation.value[`${name}`] = {
            ...eijnsApp.navigation[e].meta,
            url: `/${name}`,
            order: order,
        };

        if (eijnsApp.navigation[e].navigation) {
            navigation.value[`${name}`]['navigation'] =
                eijnsApp.navigation[e].navigation;
        }
    });

    // console.log('CRED', eijnsApp.navigation)
    // console.log('appStore', appStore)
});

onUnmounted(async () => {
    //eventMessagesCount.close();
});

const goto = (val) => {
    window.location.href = val;
};
</script>
